import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { MatDialog } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [AngularFireAuth, CookieService]
})
export class HomeComponent implements OnInit {
  constructor(private afAuth : AngularFireAuth,
              private cookieService: CookieService,
              public dialog : MatDialog) { }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      if(user && !this.cookieService.get('disclaimer')){
        const disclaimer = this.dialog.open(DisclaimerComponent, {
          data: {
            user: user
          }
        });
      }
    })
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/home/home.component.ts